import React from "react"
import { useSelector } from "react-redux"
import { FormattedMessage } from "react-intl"
import { Stack, Typography, useTheme } from "@carrotfertility/carotene-core"
import { getConsumerSubscription } from "#/redux/reducers/userInfo"
import { useUserRole } from "#/components/partner-access/hooks/usePartnerAccess"
import { isExternalStorefrontMember } from "#/services/consumerSubscription/externalStorefront"
import { SettingsPageDivider } from "#/pages/account/page"
import { ExternalStorefrontSubscriptionLinks } from "./ExternalStorefrontSubscriptionLinks"

// Account settings' subscription section. Only an external-storefront member gets one: a carrot-store
// member manages billing on /consumer/billing-detail, which the user menu links to, and an enterprise
// member has no subscription at all. Hidden from a partner using the member's account, who has no say
// over the member's purchase.
export function ExternalStorefrontSubscriptionSettings(): JSX.Element | null {
  const theme = useTheme()
  const { isPartnerAccessingAccount } = useUserRole()
  const consumerSubscription = useSelector(getConsumerSubscription)?.value

  if (isPartnerAccessingAccount || !consumerSubscription || !isExternalStorefrontMember(consumerSubscription)) {
    return null
  }
  return (
    <>
      <Stack spacing={theme.spacing(theme.tokens.spacing.lg)}>
        <Typography variant="h2">
          <FormattedMessage defaultMessage="Subscription" />
        </Typography>
        <ExternalStorefrontSubscriptionLinks storefront={consumerSubscription.storefront} />
      </Stack>
      <SettingsPageDivider />
    </>
  )
}
